const ID = {
    modal: 'fb-modal-dynamic-modal',
    modalTitle: 'fb-modal-dynamic-modal-title',
    modalBody: 'fb-modal-dynamic-modal-body',

}

const CLASSES = {
    modalBtn: 'fb-modal-dynamic-modal-btn',
    modalTitleContent: 'fb-modal-dynamic-modal-title-content',
    modalBodyContent: 'fb-modal-dynamic-modal-body-content'
}

const modal = document.getElementById(ID.modal);
const modalBtnNodes = document?.querySelectorAll('.' + CLASSES.modalBtn);
let modalTitle = document?.getElementById(ID.modalTitle);
let modalBody = document?.getElementById(ID.modalBody);
let modalTitleContent;
let modalBodyContent;
 
const init = () => {
    if (modalBtnNodes != null) {
        for (let i = 0; i < modalBtnNodes.length; i++) {
            let item = modalBtnNodes[i];

            item.addEventListener('click', () => {
                assignContent(item);
            });
        }
    }
}

const assignContent = (item) => {

    modalTitleContent = item.querySelector('.' + CLASSES.modalTitleContent);
    modalBodyContent = item.querySelector('.' + CLASSES.modalBodyContent);

    modalTitleContent != null && modalTitleContent.innerText != '' ? modalTitle.innerText = modalTitleContent.innerText : '';
    modalBodyContent != null && modalBodyContent.innerText != '' ? modalBody.innerText = modalBodyContent.innerText : '';

    resetModal();
}

const resetModal = () => {
    modal.addEventListener('hidden.bs.modal', () => {
        modalTitle.innerText = '';
        modalBody.innerText = '';
    });
}

export default {
    init
}